/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentNumberSettingModel { 
    documentNumberSettingId?: number;
    documentTypeId?: number;
    documentGroupName?: string | null;
    documentNumberIdentifier?: string | null;
    documentNumberLength?: number;
    documentNumberId?: number;
    statusId?: number;
    documentTypeName?: string | null;
}

